import React, {useEffect, useState} from 'react';
import {BoxTitle} from "../../../components/admin/BoxTitle";
import {RaceForm} from "../../../components/admin/race/RaceForm";
import {useParams} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {raceResultType} from "../../../types/Api/RaceResultType";
import {raceHydrator} from "../../../models/hydrator/raceHydrator";
import {race} from "../../../models/race";
import {Loader} from "../../../components/admin/Loader";

export const Edit = () => {
  const uuid: undefined | string = useParams().uuid;

  const [race, setRace] = useState(undefined as undefined | race);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (uuid) {
      const result = ApiService.get(`/race/${uuid}`) as Promise<raceResultType>;

      setLoading(true);

      result
        .then((r) => {
          setRace(raceHydrator.hydrate(r));
        })
        .catch(() => {
          alert("Une erreur c'est produite.")
        })
        .finally(() => {
          setLoading(false);
        });
    }

  }, [uuid]);

  return (
    <>
      {loading && (
        <Loader/>
      )}

      {!loading && (race || !uuid) && (
        <>
          <BoxTitle title="Modifier une sortie"/>
          <RaceForm race={race} seasonId={race?.season?.seasonId} />
        </>
      )}
      
    </>
  )
}
